export const resolveFullSnippetPath = (relativePath: string) => {
  return `${
    window.location.host.includes('localhost')
      ? 'http://localhost:3000'
      : 'https://www.paypalobjects.com/ppdevdocs/migrationv1'
  }${relativePath}`
}
